import { defineProductDimensions, frAupaPricingVersionDimension, frAupaSelectedDimension } from '@orus.eu/dimensions'

import { frAupaProductVersionDimension } from './fr-aupa-dimensions.ts'
import { frAupaQuoteDimension } from './fr-aupa-quote-dimension.ts'

export * from './fr-aupa-activity-dimension.ts'
export * from './fr-aupa-assistance-premiums-dimension.ts'
export * from './fr-aupa-bonus-malus-exclusion-messages.ts'
export * from './fr-aupa-claims-counts-dimension.ts'
export * from './fr-aupa-claims-history-dimension.ts'
export * from './fr-aupa-dimensions.ts'
export * from './fr-aupa-driver-date-exclusion-messages.ts'
export * from './fr-aupa-exclusions.ts'
export * from './fr-aupa-fee-dimensions.ts'
export * from './fr-aupa-formula-premiums-dimension.ts'
export * from './fr-aupa-general-deductible-dimension.ts'
export * from './fr-aupa-main-driver.ts'
export * from './fr-aupa-policy-item-dimensions.ts'
export * from './fr-aupa-quote-dimension.ts'
export * from './fr-aupa-subscription-ui.ts'
export * from './fr-aupa-ui-elements.ts'

export const frAupaDimensionsModule = defineProductDimensions({
  product: 'fr-aupa',
  family: null,
  selectionDimension: frAupaSelectedDimension,
  productVersionDimension: frAupaProductVersionDimension,
  pricingVersionDimension: frAupaPricingVersionDimension,
  quoteV3Dimension: frAupaQuoteDimension,
})
